import { WhiteListAuditStatus } from '@/constants/enum'
import styles from '@/views/Setting/pannels/WhiteList/index.module.scss'
import i18n from '@/services/i18n'
import policy from '@/services/apis/policy'
// 获取样式
export function whiteListStatusColorClass(value: WhiteListAuditStatus, isActive: boolean) {
  const colorMap = {
    [WhiteListAuditStatus.NOSUBMITTED]: styles.normal,
    [WhiteListAuditStatus.INAPPRVAL]: styles.waiting,
    [WhiteListAuditStatus.PASSED]: styles.success,
    [WhiteListAuditStatus.REJECT]: styles.danger,
    [WhiteListAuditStatus.CANCELLED]: styles.danger,
    [WhiteListAuditStatus.MODIFIY]: isActive ? styles.success : styles.danger,
  }
  return colorMap[value]
}

// 获取生效状态
export function getWhiteListStatusText(value: WhiteListAuditStatus, isActive: boolean) {
  switch (value) {
    case WhiteListAuditStatus.NOSUBMITTED:
      return i18n.t('policy.notSubmit')
    case WhiteListAuditStatus.PASSED:
      return i18n.t('policy.valid')
    case WhiteListAuditStatus.CANCELLED:
      return i18n.t('enum.txStatus.Cancelled')
    case WhiteListAuditStatus.INAPPRVAL:
      return i18n.t('txRecord.pending')
    case WhiteListAuditStatus.REJECT:
      return i18n.t('policy.reject')
    case WhiteListAuditStatus.MODIFIY: {
      return isActive ? i18n.t('policy.valid') : i18n.t('policy.reject')
    }
  }
}

// 获取是否存在关联策略
export async function queryRules(addressBookKey: string) {
  const autoSweepRes = await policy.queryAutoSweepRulesByAddressBookKey({
    addressBookKey,
  })

  const txRes = await policy.queryTxRulesByAddressBookKey({
    addressBookKey,
  })
  return {
    autoSweepRes,
    txRes,
  }
}

// 获取二维码数据
export function ParseQrcode(video: any, current: any) {
  current = document.createElement('canvas')
  const context = current.getContext('2d')
  current.width = video.width
  current.height = video.height
  context?.drawImage(video, 0, 0, video.width, video.height)
  const imageData = context?.getImageData(0, 0, video.width, video.height)
  return imageData
}
